import { CUSTOM_ATTRIBUTES_DATA_MAP_KEY_NAME } from "models/generateCustomAttributesSchema";

export function buildDraftAuditFormResetData(data: any) {
  if (!data) {
    return {};
  }

  return {
    ...data,
    ...(data[CUSTOM_ATTRIBUTES_DATA_MAP_KEY_NAME] || {}),
  };
}
